import { BASE_URL, s3Path } from '../../general/variables';
import { processFirebase } from './firebase';
import { ellipseText, getUrlParameter, initDefaultSelect2, makeKTBlock, makeSwal, nl2br, number_format, svgLoader, ucwords } from '../../general/functions';

let defaultBugetApprovalFile = `${s3Path}Event/Invoice`;
let userAgent = $('#userAgent').val();
const initTotalBudgeting = () => {
  makeKTBlock('#body_form_budget');
  $.ajax({
    url: `${BASE_URL}C_Event/budgetingCount?id=${getUrlParameter('id')}`,
    method: 'get',
    dataType: 'JSON',
    data: {},
    success: function (response) {
      const { results } = response;
      $.each(results.childs, function (index, value) {
        var totalBudget = $(`#total_${index}`).data('value');
        var calculatedBudget = parseInt(totalBudget) - parseInt(value);
        $(`#total_${index} span`).text(number_format(totalBudget, 'IDR'));
        $(`#total_budget_${index}_used span`).text(number_format(value, 'IDR'));
        $(`#total_remaining_${index}_budget span`).text(number_format(calculatedBudget, 'IDR'));
        if (calculatedBudget > 0) {
          $(`#total_remaining_${index}_budget span`).removeClass('label-danger').addClass('label-dark');
        } else {
          $(`#total_remaining_${index}_budget span`).removeClass('label-dark').addClass('label-danger');
        }
      });

      $('#total_external_budget_event').text(number_format(results.parents.external, 'IDR'));
      $('#total_budget_event').text(number_format(results.parents.all, 'IDR'));
      $('#total_used_budget_event').text(number_format(results.parents.used, 'IDR'));
      let remainingData = results.parents.remaining.split('#');
      $('#total_remaining_budget_event').html(`
        <label class="font-weight-bolder">Remaining Budget : </label><br>
        <span class="label label-inline label-${remainingData[1]} fs-6 p-4 fw-bolder maskCurrencyGlobal"> ${number_format(remainingData[0], 'IDR')} </span>
    `);

      makeKTBlock('#body_form_budget', 'hide');
    },
    error: function (data) {
      Swal.fire({
        title: data.statusText,
        html: data.responseText,
        icon: 'error',
      });
    },
  });
};

const initAllBudgetFormScript = () => {
  $('#btn-submit-budget').prop('disabled', false);

  if ($('.select2-budget-categories').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}C_Event/getBudgetCategories`,
      },
      '.select2-budget-categories',
      $('#modal_form_budget'),
      $(this).data('placeholder')
    );
  }

  if ($('.select2-cities').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}Select2Controller/getCities`,
      },
      '.select2-cities',
      $('#modal_form_budget'),
      $(this).data('placeholder')
    );
  }

  if ($('.select2-no-search').length) {
    initDefaultSelect2(false, null, '.select2-no-search', undefined, 'Choose...');
  }

  if ($('.select2-createable').length) {
    initDefaultSelect2(false, null, '.select2-createable', undefined, 'Choose...', true, true);
  }

  if ($('.select2-location').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}Select2Controller/getAreas`,
      },
      '.select2-location',
      $('#modal_form_budget'),
      $(this).data('placeholder'),
      false
    );
  }

  if ($('.media_offline_vendor_id').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}/Select2Controller/getVendors`,
        data: {
          is_media_offline: true,
        },
      },
      '.media_offline_vendor_id',
      undefined,
      'Choose Media Offline',
      false,
      false,
      true,
      Infinity,
      false,
      {
        show: true,
        content: 'No results found. <a class="btn btn-sm btn-primary quickAddVendor">Create new Vendor</a>',
      },
      true
    );

    $(document).on('select2:select', '.media_offline_vendor_id', function (e) {
      // $('#media_offline_vendor_name').val(e.params.data.text)
      var elemContainer = $(this).parents('.container_first_repeater');
      $(elemContainer).find('.media_offline_vendor_name').val(e.params.data.text);
    });
  }

  if ($('.media_partner_vendor_id').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}/Select2Controller/getVendors`,
        data: {
          is_media_partner: true,
        },
      },
      '.media_partner_vendor_id',
      undefined,
      'Choose Media Partner',
      false,
      false,
      true,
      Infinity,
      false,
      {
        show: true,
        content: 'No results found. <a class="btn btn-sm btn-primary quickAddVendor">Create new Vendor</a>',
      },
      true
    );

    $(document).on('select2:select', '.media_partner_vendor_id', function (e) {
      // $('#media_partner_vendor_name').val(e.params.data.text)
      var elemContainer = $(this).parents('.container_first_repeater');
      $(elemContainer).find('.media_partner_vendor_name').val(e.params.data.text);
    });
  }

  if ($('.venue_id').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}/Select2Controller/getVendors`,
        data: {
          is_venue: true,
        },
      },
      '.venue_id',
      undefined,
      'Choose Venue',
      false,
      false,
      true,
      Infinity,
      false,
      {
        show: true,
        content: 'No results found. <a class="btn btn-sm btn-primary quickAddVendor">Create new Vendor</a>',
      },
      true
    );

    $(document).on('select2:select', '.venue_id', function (e) {
      // $('#venue_name').val(e.params.data.text)
      var elemContainer = $(this).parents('.container_first_repeater');
      $(elemContainer).find('.venue_name').val(e.params.data.text);
    });
  }

  if ($('.media_offline_materi_iklan').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}/Select2Controller/getVendorTypes`,
      },
      '.media_offline_materi_iklan',
      undefined,
      'Choose advertising materials'
    );
  }

  if ($('.maskCurrencyGlobal').length) {
    $('.maskCurrencyGlobal').mask('000.000.000.000.000', {
      reverse: true,
      translation: {
        0: { pattern: /\d/ },
        9: { pattern: /\d/, optional: true },
        Z: { pattern: /[\-\+]/, optional: true },
      },
    });
  }

  if ($('.maskPpn').length) {
    $('.maskPpn').mask('000', {
      reverse: true,
    });
  }

  if ($('#modal_offline_daterangepicker').length) {
    $('#modal_offline_daterangepicker').daterangepicker(
      {
        buttonClasses: ' btn',
        applyClass: 'btn-primary',
        cancelClass: 'btn-secondary',
      },
      function (start, end, label) {
        $('#modal_offline_daterangepicker .form-control').val(start.format('YYYY-MM-DD') + ' / ' + end.format('YYYY-MM-DD'));
      }
    );
  }

  if ($('.select2-employee').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}Select2Controller/getEmployees`,
        data: { is_group: true },
      },
      '.select2-employee',
      $('#modal_form_budget'),
      $(this).data('placeholder')
    );
  }

  if ($('.switchPpn').length) {
    $(document).on('click', '.switchPpn', function (e) {
      var elemContainer = $(this).parents('.container_first_repeater');
      if ($(this).is(':checked')) {
        $(elemContainer).find('.containerPercentasePPN').show();
      } else {
        $(elemContainer).find('.inputPPN').val(0);
        $(elemContainer).find('input[name="grandtotal[]"]').val(0);
        $(elemContainer).find('.containerPercentasePPN').hide();
      }
    });
  }

  if ($('.switchDesignOrder').length) {
    $(document).on('click', '.switchDesignOrder', function (e) {
      var elemContainer = $(this).parents('.container_first_repeater');
      if ($(this).is(':checked')) {
        $(elemContainer).find('.container-designOrder').show();
        // $('.container-designOrder').show()
      } else {
        $(elemContainer).find('.container-designOrder').hide();
        // $('.container-designOrder').hide()
      }
    });
  }

  if ($('.toggleCalculate').length) {
    var typingTimer,
      doneTypingInterval = 500;
    $(document).on('keyup input', '.toggleCalculate', function (e) {
      e.preventDefault();

      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        let categoryForm = $(this).data('calculated');
        var elemContainer = $(this).parents('.container_first_repeater');
        let containerBlock = `.container${ucwords(categoryForm.replace('_', ' ')).replace(' ', '')}GT`;
        var result = 0;
        let grandTotal = $(elemContainer).find(`.${categoryForm}_grandtotal`),
          total = $(elemContainer).find(`.${categoryForm}_total`).cleanVal() ? parseInt($(elemContainer).find(`.${categoryForm}_total`).cleanVal()) : 0;

        makeKTBlock(containerBlock);

        if ($('.switchPpn').is(':checked')) {
          // let value = $(`input.${categoryForm}_ppn`).val()
          let value = $(elemContainer).find(`.${categoryForm}_ppn`).val();

          if (parseInt(value) !== 0) {
            let convertPPN = /^00/.test(value) ? value.replace(/^00/, '') : value;
            convertPPN = /^0/.test(convertPPN) ? convertPPN.replace(/^0/, '') : convertPPN;
            // $('.inputPPN').val(convertPPN)
            $(elemContainer).find(`.inputPPN`).val(convertPPN);
          }

          if (value > 100) {
            Swal.fire({
              title: 'Warning!',
              icon: 'warning',
              html: 'PPN maksimal 100%, silahkan masukkan ppn antara 1 - 100 %',
              showCancelButton: false,
              confirmButtonText: 'Close',
            });
            $('#btn-submit-budget').prop('disabled', true);
            return;
          }
          $('#btn-submit-budget').prop('disabled', false);

          clearTimeout(typingTimer);
          typingTimer = setTimeout(() => {
            let temp = (total * value) / 100;
            if (value !== 0) {
              result = total + parseInt(temp);
            } else {
              result = total;
            }
            grandTotal.unmask();
            grandTotal.val(result);
            grandTotal.mask('000.000.000.000.000', { reverse: true });

            if (containerBlock !== null) {
              makeKTBlock(containerBlock, 'hide');
            }
          }, 1000);

          // Karna repeater tidak pakai global calculatedTotal funciton
          // Calculated total and ppn
          // calculatedTotal('percentase', `input.${grandTotal}_grandtotal`, `input.${categoryForm}_total`, `input.${categoryForm}_ppn`, 2000, containerBlock)
        } else {
          // Jika ppn tidak di toggle
          clearTimeout(typingTimer);
          typingTimer = setTimeout(() => {
            grandTotal.unmask();
            grandTotal.val(total);
            grandTotal.mask('000.000.000.000.000', { reverse: true });

            if (containerBlock !== null) {
              makeKTBlock(containerBlock, 'hide');
            }
          }, 800);
        }
      }, doneTypingInterval);
    });
  }
};

const venueColumns = [
  { data: 'NAME', className: 'fw-bolder' },
  { data: 'STATUS', className: 'text-center' },
  { data: 'STATUS_PEMBAYARAN', className: 'text-center' },
  { data: null, className: '', orderable: false },
  { data: null, className: '', orderable: false },
  { data: null, className: '', orderable: false },
  { data: null, className: 'text-center', orderable: false },
  { data: null, className: '', orderable: false },
  { data: null, className: '' },
  { data: null, className: 'fw-bolder' },
  { data: null, className: 'text-center' },
  { data: null, className: 'text-center' },
  { data: null, className: 'text-center' },
  { data: null, className: 'text-center' },
];

const venueColumnDefs = [
  {
    targets: 0,
    render: function (data, type, row) {
      return row.NAME ?? '';
    },
  },
  {
    targets: 1,
    render: function (data, type, row) {
      let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : null;
      return additionalsDT?.paket_meeting ?? '';
    },
  },
  {
    targets: 2,
    render: function (data, type, row) {
      let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : null;
      return additionalsDT?.nama_ruangan ?? '';
    },
  },
  {
    targets: 3,
    render: function (data, type, row) {
      let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : null;
      return additionalsDT?.harga_pax ? number_format(additionalsDT.harga_pax, 'IDR') : number_format(0, 'IDR');
    },
  },
  {
    targets: 4,
    render: function (data, type, row) {
      let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : null;
      return additionalsDT?.jumlah_pax ?? '-';
    },
  },
  {
    targets: 5,
    render: function (data, type, row) {
      let $color = 'danger';
      switch (row.STATUS) {
        case 'ON PROCESS':
          $color = 'warning';
          break;
        case 'DEAL':
          $color = 'success';
          break;
      }
      return `<span class="label label-inline label-${$color} text-uppercase fw-bolder">${row.STATUS}</span>`;
    },
  },
  {
    targets: 6,
    render: function (data, type, row) {
      var txtColor = 'light-dark';
      if (row.STATUS_PEMBAYARAN == 'UNPAID') {
        txtColor = 'danger';
      } else if (row.STATUS_PEMBAYARAN == 'PAID') {
        txtColor = 'success';
      }
      return `<span class="label label-inline label-${txtColor} text-uppercase fw-bolder">${row.STATUS_PEMBAYARAN}</span>`;
    },
  },
  {
    targets: 7,
    render: function (data, type, row) {
      let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
      return additionalsDT?.notes ? `<div ${additionalsDT.notes.length >= 50 ? `class="togglePopover" data-toggle="popover" data-content="${additionalsDT.notes}"` : ''}>${nl2br(ellipseText(additionalsDT.notes, 50, true))}</div>` : '-';
    },
  },
  {
    targets: 8,
    render: function (data, type, row) {
      return !row.TOTAL ? '-' : `${number_format(row.TOTAL, 'IDR')} ${row.PPN && row.PPN != 0 ? `(<span class="fw-bolder">${row.PPN}%</span>)` : ''}`;
    },
  },
  {
    targets: 9,
    render: function (data, type, row) {
      return !row.GRANDTOTAL ? '-' : `<span class="text-decoration-underline">${number_format(row.GRANDTOTAL, 'IDR')}</span>`;
    },
  },
  {
    targets: 10,
    render: function (data, type, row) {
      let invoiceFile = '',
        approvalFile = '';

      invoiceFile = !row.FILE
        ? invoiceFile
        : `
        <li class="d-flex flex-start">
          <a href="${row.FILE}" class="btn btn-sm btn-light-warning text-dark fw-bolder border border-warning btn-block mb-3" target="_blank">Invoice File</a>
        </li>
      `;

      if (row?.INVOICE && row?.INVOICE_DATA?.APPROVE_FILE) {
        let defPath = `${defaultBugetApprovalFile}/${row.EVENT_ID}/BUKTI`;
        approvalFile = `
          <li class="d-flex flex-start">
            <a href="${defPath}/${row.INVOICE_DATA.APPROVE_FILE}" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block" target="_blank">Payment Approval</a>
          </li>
        `;
      }

      return `
        <ul class="list-unstyled">
          ${invoiceFile}
          ${approvalFile}
        </ul>
      `;
    },
  },
  {
    targets: 11,
    render: function (data, type, row) {
      let additionalFiles = '',
        additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

      if (additionalsDT?.other_files) {
        $.each(additionalsDT.other_files, function (i, value) {
          // additionalFiles += `<button type="button" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block">Additional Docs</button>`
          additionalFiles += `
            <li class="d-flex flex-start">
              <a href="${value}" class="btn btn-sm btn-light-dark fw-bolder border border-dark btn-block mb-3" target="_blank">Docs ${++i}</a>
            </li>
          `;
        });
      }

      return `
        <ul class="list-unstyled">
          ${additionalFiles}
        </ul>
      `;
    },
  },
  {
    targets: 12,
    render: function (data, type, row) {
      let creatorName = row.CREATED_NAME.length < 10 ? row.CREATED_NAME : `<span class="togglePopover" data-toggle="popover" data-content="${row.CREATED_NAME}">${ellipseText(row.CREATED_NAME, 10, true)}</span>`,
        createdAt = !row.CREATED_AT ? '-' : `${moment(row.CREATED_AT).format('D MMM YYYY')}`;
      return `
        <ul class="list-unstyled m-0">
          <li class="fw-bolder">${creatorName}</li>
          <li>${createdAt}</li>
        </ul>
      `;
    },
  },
  {
    targets: 13,
    render: function (data, type, row) {
      var deleteBtn = `
        <div class="dropdown-divider opacity-75"></div>
        <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
          <i class="fas fa-trash text-danger mr-3"></i> Delete
        </a>
      `;

      if (curDIVISIONKEY != '291e255817') {
        deleteBtn = ['UNPAID', 'PAID'].includes(row.STATUS_PEMBAYARAN)
          ? ''
          : `
          <div class="dropdown-divider opacity-75"></div>
          <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
            <i class="fas fa-trash text-danger mr-3"></i> Delete
          </a>
        `;
      }
      return `
        <div class="dropdown dropdown-inline">
            <button type="button" class="btn btn-light-dark btn-icon btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="ki ki-bold-more-hor"></i>
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item fw-bolder btnEditBudget" href="javascript:;" data-id="${row.REC_ID}">
                <i class="fas fa-pencil-alt mr-3"></i> Edit
              </a>
              ${deleteBtn}
            </div>
        </div>
      `;
    },
  },
];

var firstInitColumns, firstInitColumnDefs;
const endorseColumns = [
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
  ],
  studentShareColumns = [
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
  ],
  mediaOfflineColumns = [
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
  ],
  mediaPartnerColumns = [
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
  ],
  entertainColumns = [
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
  ],
  onlineAdsColumns = [
    { data: null, className: '' },
    { data: null, className: 'text-center' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
  ],
  defaultsColumns = [
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: '' },
    { data: null, className: 'fw-bolder' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
    { data: null, className: 'text-center' },
  ],
  designOrderColumns = [
    { data: 'DESCRIPTION', className: '' },
    { data: null, className: '', orderable: false },
    { data: 'STATUS', className: 'text-center' },
    { data: 'STAFF_ID', className: '' },
  ];

const endorseColumnDefs = [
    {
      targets: 0,
      render: function (data, type, row) {
        let tiktokComponent = '',
          instagramComponent = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        tiktokComponent = additionalsDT?.account_tiktok
          ? `
        <div class="d-flex flex-start">
          <div class="w-30px h-30px d-flex flex-center">
            <i class="fab fa-tiktok text-dark font-weight-bolder"></i>
          </div>
          <a href="https://www.tiktok.com/${additionalsDT.account_tiktok ? (additionalsDT.account_tiktok.includes('@') ? additionalsDT.account_tiktok : `@${additionalsDT.account_tiktok}`) : ''}" target="_blank" class="ml-2 fw-bolder">${additionalsDT.account_tiktok} ${additionalsDT.followers_tiktok ? `<div class="text-dark fw-normal">(${additionalsDT.followers_tiktok})</div>` : ''}</a>
        </div>
      `
          : tiktokComponent;

        instagramComponent = additionalsDT?.account_instagram
          ? `
        <div class="d-flex flex-start">
          <div class="w-30px h-30px d-flex flex-center">
            <i class="fab fa-instagram text-danger font-weight-bolder"></i>
          </div>
          <a href="https://www.instagram.com/${additionalsDT.account_instagram ? additionalsDT.account_instagram : ''}/" target="_blank" class="ml-2 fw-bolder">${additionalsDT.account_instagram ? additionalsDT.account_instagram : ''} ${additionalsDT.followers_instagram ? `<div class="text-dark fw-normal">(${additionalsDT.followers_instagram})</div>` : ''}</a>
        </div>
      `
          : instagramComponent;

        return `
        <div class="">
          ${tiktokComponent}
          ${instagramComponent}
        </div>
      `;
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        return !row.CITY_ID ? '-' : row.CITIES_NAME;
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        var txtColor = 'light-dark';
        if (row.STATUS_PEMBAYARAN == 'UNPAID') {
          txtColor = 'danger';
        } else if (row.STATUS_PEMBAYARAN == 'PAID') {
          txtColor = 'success';
        }
        return `<span class="label label-inline label-${txtColor} text-uppercase fw-bolder">${row.STATUS_PEMBAYARAN}</span>`;
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
        return additionalsDT?.notes ? `<div ${additionalsDT.notes.length >= 50 ? `class="togglePopover" data-toggle="popover" data-content="${additionalsDT.notes}"` : ''}>${nl2br(ellipseText(additionalsDT.notes, 50, true))}</div>` : '-';
      },
    },
    {
      targets: 4,
      render: function (data, type, row) {
        return !row.TOTAL ? '-' : `${number_format(row.TOTAL, 'IDR')} ${row.PPN && row.PPN != 0 ? `(<span class="fw-bolder">${row.PPN}%</span>)` : ''}`;
      },
    },
    {
      targets: 5,
      render: function (data, type, row) {
        return !row.GRANDTOTAL ? '-' : `<span class="text-decoration-underline">${number_format(row.GRANDTOTAL, 'IDR')}</span>`;
      },
    },
    {
      targets: 6,
      render: function (data, type, row) {
        let invoiceFile = '',
          approvalFile = '';

        invoiceFile = !row.FILE
          ? invoiceFile
          : `
          <li class="d-flex flex-start">
            <a href="${row.FILE}" class="btn btn-sm btn-light-warning text-dark fw-bolder border border-warning btn-block mb-3" target="_blank">Invoice File</a>
          </li>
        `;

        if (row?.INVOICE && row?.INVOICE_DATA?.APPROVE_FILE) {
          let defPath = `${defaultBugetApprovalFile}/${row.EVENT_ID}/BUKTI`;
          approvalFile = `
          <li class="d-flex flex-start">
            <a href="${defPath}/${row.INVOICE_DATA.APPROVE_FILE}" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block" target="_blank">Payment Approval</a>
          </li>
        `;
        }

        return `
        <ul class="list-unstyled">
          ${invoiceFile}
          ${approvalFile}
        </ul>
      `;
      },
    },
    {
      targets: 7,
      render: function (data, type, row) {
        let additionalFiles = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        if (additionalsDT?.other_files) {
          $.each(additionalsDT.other_files, function (i, value) {
            // additionalFiles += `<button type="button" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block">Additional Docs</button>`
            additionalFiles += `
            <li class="d-flex flex-start">
              <a href="${value}" class="btn btn-sm btn-light-dark fw-bolder border border-dark btn-block mb-3" target="_blank">Docs ${++i}</a>
            </li>
          `;
          });
        }

        return `
        <ul class="list-unstyled">
          ${additionalFiles}
        </ul>
      `;
      },
    },
    {
      targets: 8,
      render: function (data, type, row) {
        let creatorName = row.CREATED_NAME.length < 10 ? row.CREATED_NAME : `<span class="togglePopover" data-toggle="popover" data-content="${row.CREATED_NAME}">${ellipseText(row.CREATED_NAME, 10, true)}</span>`,
          createdAt = !row.CREATED_AT ? '-' : `${moment(row.CREATED_AT).format('D MMM YYYY')}`;
        return `
        <ul class="list-unstyled m-0">
          <li class="fw-bolder">${creatorName}</li>
          <li>${createdAt}</li>
        </ul>
      `;
      },
    },
    {
      targets: 9,
      render: function (data, type, row) {
        var deleteBtn = `
        <div class="dropdown-divider opacity-75"></div>
        <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
          <i class="fas fa-trash text-danger mr-3"></i> Delete
        </a>
      `;

        if (curDIVISIONKEY != '291e255817') {
          deleteBtn = ['UNPAID', 'PAID'].includes(row.STATUS_PEMBAYARAN)
            ? ''
            : `
          <div class="dropdown-divider opacity-75"></div>
          <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
            <i class="fas fa-trash text-danger mr-3"></i> Delete
          </a>
        `;
        }
        return `
          <div class="dropdown dropdown-inline">
              <button type="button" class="btn btn-light-dark btn-icon btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="ki ki-bold-more-hor"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item fw-bolder btnEditBudget" href="javascript:;" data-id="${row.REC_ID}">
                  <i class="fas fa-pencil-alt mr-3"></i> Edit
                </a>
                ${deleteBtn}
              </div>
          </div>
          `;
      },
    },
  ],
  studentShareColumnDefs = [
    {
      targets: 0,
      render: function (data, type, row) {
        let tiktokComponent = '',
          instagramComponent = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        tiktokComponent = additionalsDT?.account_tiktok
          ? `
          <div class="d-flex flex-start">
            <div class="w-30px h-30px d-flex flex-center">
              <i class="fab fa-tiktok text-dark font-weight-bolder"></i>
            </div>
            <a href="https://www.tiktok.com/${additionalsDT.account_tiktok ? (additionalsDT.account_tiktok.includes('@') ? additionalsDT.account_tiktok : `@${additionalsDT.account_tiktok}`) : ''}" target="_blank" class="ml-2 fw-bolder">${additionalsDT.account_tiktok} ${additionalsDT.followers_tiktok ? `<div class="text-dark fw-normal">(${additionalsDT.followers_tiktok})</div>` : ''}</a>
          </div>
        `
          : tiktokComponent;

        instagramComponent = additionalsDT?.account_instagram
          ? `
          <div class="d-flex flex-start">
            <div class="w-30px h-30px d-flex flex-center">
              <i class="fab fa-instagram text-danger font-weight-bolder"></i>
            </div>
            <a href="https://www.instagram.com/${additionalsDT.account_instagram ? additionalsDT.account_instagram : ''}/" target="_blank" class="ml-2 fw-bolder">${additionalsDT.account_instagram ? additionalsDT.account_instagram : ''} ${additionalsDT.followers_instagram ? `<div class="text-dark fw-normal">(${additionalsDT.followers_instagram})</div>` : ''}</a>
          </div>
        `
          : instagramComponent;

        return `
          <div class="">
            ${tiktokComponent}
            ${instagramComponent}
          </div>
        `;
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        return !row.STAFF_ID ? '-' : row.STAFF_NAME;
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        var txtColor = 'light-dark';
        if (row.STATUS_PEMBAYARAN == 'UNPAID') {
          txtColor = 'danger';
        } else if (row.STATUS_PEMBAYARAN == 'PAID') {
          txtColor = 'success';
        }
        return `<span class="label label-inline label-${txtColor} text-uppercase fw-bolder">${row.STATUS_PEMBAYARAN}</span>`;
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
        return additionalsDT?.notes ? `<div ${additionalsDT.notes.length >= 50 ? `class="togglePopover" data-toggle="popover" data-content="${additionalsDT.notes}"` : ''}>${nl2br(ellipseText(additionalsDT.notes, 50, true))}</div>` : '-';
      },
    },
    {
      targets: 4,
      render: function (data, type, row) {
        return !row.TOTAL ? '-' : `${number_format(row.TOTAL, 'IDR')} ${row.PPN && row.PPN != 0 ? `(<span class="fw-bolder">${row.PPN}%</span>)` : ''}`;
      },
    },
    {
      targets: 5,
      render: function (data, type, row) {
        return !row.GRANDTOTAL ? '-' : `<span class="text-decoration-underline">${number_format(row.GRANDTOTAL, 'IDR')}</span>`;
      },
    },
    {
      targets: 6,
      render: function (data, type, row) {
        let invoiceFile = '',
          approvalFile = '';

        invoiceFile = !row.FILE
          ? invoiceFile
          : `
          <li class="d-flex flex-start">
            <a href="${row.FILE}" class="btn btn-sm btn-light-warning text-dark fw-bolder border border-warning btn-block mb-3" target="_blank">Invoice File</a>
          </li>
        `;

        if (row?.INVOICE && row?.INVOICE_DATA?.APPROVE_FILE) {
          let defPath = `${defaultBugetApprovalFile}/${row.EVENT_ID}/BUKTI`;
          approvalFile = `
          <li class="d-flex flex-start">
            <a href="${defPath}/${row.INVOICE_DATA.APPROVE_FILE}" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block" target="_blank">Payment Approval</a>
          </li>
        `;
        }

        return `
          <ul class="list-unstyled">
            ${invoiceFile}
            ${approvalFile}
          </ul>
        `;
      },
    },
    {
      targets: 7,
      render: function (data, type, row) {
        let additionalFiles = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        if (additionalsDT?.other_files) {
          $.each(additionalsDT.other_files, function (i, value) {
            // additionalFiles += `<button type="button" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block">Additional Docs</button>`
            additionalFiles += `
            <li class="d-flex flex-start">
              <a href="${value}" class="btn btn-sm btn-light-dark fw-bolder border border-dark btn-block mb-3" target="_blank">Docs ${++i}</a>
            </li>
          `;
          });
        }

        return `
        <ul class="list-unstyled">
          ${additionalFiles}
        </ul>
      `;
      },
    },
    {
      targets: 8,
      render: function (data, type, row) {
        let creatorName = row.CREATED_NAME.length < 10 ? row.CREATED_NAME : `<span class="togglePopover" data-toggle="popover" data-content="${row.CREATED_NAME}">${ellipseText(row.CREATED_NAME, 10, true)}</span>`,
          createdAt = !row.CREATED_AT ? '-' : `${moment(row.CREATED_AT).format('D MMM YYYY')}`;
        return `
          <ul class="list-unstyled m-0">
            <li class="fw-bolder">${creatorName}</li>
            <li>${createdAt}</li>
          </ul>
        `;
      },
    },
    {
      targets: 9,
      render: function (data, type, row) {
        var deleteBtn = `
          <div class="dropdown-divider opacity-75"></div>
          <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
            <i class="fas fa-trash text-danger mr-3"></i> Delete
          </a>
        `;

        if (curDIVISIONKEY != '291e255817') {
          deleteBtn = ['UNPAID', 'PAID'].includes(row.STATUS_PEMBAYARAN)
            ? ''
            : `
            <div class="dropdown-divider opacity-75"></div>
            <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
              <i class="fas fa-trash text-danger mr-3"></i> Delete
            </a>
          `;
        }
        return `
          <div class="dropdown dropdown-inline">
              <button type="button" class="btn btn-light-dark btn-icon btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="ki ki-bold-more-hor"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item fw-bolder btnEditBudget" href="javascript:;" data-id="${row.REC_ID}">
                  <i class="fas fa-pencil-alt mr-3"></i> Edit
                </a>
                ${deleteBtn}
              </div>
          </div>
        `;
      },
    },
  ],
  mediaOfflineColumnDefs = [
    {
      targets: 0,
      render: function (data, type, row) {
        return row.NAME;
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        return row.VENDOR_CATEGORY_NAME ?? '-';
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : null;
        return additionalsDT?.jumlah ? additionalsDT.jumlah : 0;
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        let $color = 'danger';
        switch (row.STATUS) {
          case 'ON PROCESS':
            $color = 'warning';
            break;
          case 'DEAL':
            $color = 'success';
            break;
        }
        return `<span class="label label-inline label-${$color} text-uppercase fw-bolder">${row.STATUS}</span>`;
      },
    },
    {
      targets: 4,
      render: function (data, type, row) {
        var txtColor = 'light-dark';
        if (row.STATUS_PEMBAYARAN == 'UNPAID') {
          txtColor = 'danger';
        } else if (row.STATUS_PEMBAYARAN == 'PAID') {
          txtColor = 'success';
        }
        return `<span class="label label-inline label-${txtColor} text-uppercase fw-bolder">${row.STATUS_PEMBAYARAN}</span>`;
      },
    },
    {
      targets: 5,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
        return additionalsDT?.notes ? `<div ${additionalsDT.notes.length >= 50 ? `class="togglePopover" data-toggle="popover" data-content="${additionalsDT.notes}"` : ''}>${nl2br(ellipseText(additionalsDT.notes, 50, true))}</div>` : '-';
      },
    },
    {
      targets: 6,
      render: function (data, type, row) {
        return !row.TOTAL ? '-' : `${number_format(row.TOTAL, 'IDR')} ${row.PPN && row.PPN != 0 ? `(<span class="fw-bolder">${row.PPN}%</span>)` : ''}`;
      },
    },
    {
      targets: 7,
      render: function (data, type, row) {
        return !row.GRANDTOTAL ? '-' : `<span class="text-decoration-underline">${number_format(row.GRANDTOTAL, 'IDR')}</span>`;
      },
    },
    {
      targets: 8,
      render: function (data, type, row) {
        let invoiceFile = '',
          approvalFile = '';

        invoiceFile = !row.FILE
          ? invoiceFile
          : `
          <li class="d-flex flex-start">
            <a href="${row.FILE}" class="btn btn-sm btn-light-warning text-dark fw-bolder border border-warning btn-block mb-3" target="_blank">Invoice File</a>
          </li>
        `;

        if (row?.INVOICE && row?.INVOICE_DATA?.APPROVE_FILE) {
          let defPath = `${defaultBugetApprovalFile}/${row.EVENT_ID}/BUKTI`;
          approvalFile = `
          <li class="d-flex flex-start">
            <a href="${defPath}/${row.INVOICE_DATA.APPROVE_FILE}" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block" target="_blank">Payment Approval</a>
          </li>
        `;
        }

        return `
          <ul class="list-unstyled">
            ${invoiceFile}
            ${approvalFile}
          </ul>
        `;
      },
    },
    {
      targets: 9,
      render: function (data, type, row) {
        let additionalFiles = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        if (additionalsDT?.other_files) {
          $.each(additionalsDT.other_files, function (i, value) {
            // additionalFiles += `<button type="button" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block">Additional Docs</button>`
            additionalFiles += `
            <li class="d-flex flex-start">
              <a href="${value}" class="btn btn-sm btn-light-dark fw-bolder border border-dark btn-block mb-3" target="_blank">Docs ${++i}</a>
            </li>
          `;
          });
        }

        return `
        <ul class="list-unstyled">
          ${additionalFiles}
        </ul>
      `;
      },
    },
    {
      targets: 10,
      render: function (data, type, row) {
        let creatorName = row.CREATED_NAME.length < 10 ? row.CREATED_NAME : `<span class="togglePopover" data-toggle="popover" data-content="${row.CREATED_NAME}">${ellipseText(row.CREATED_NAME, 10, true)}</span>`,
          createdAt = !row.CREATED_AT ? '-' : `${moment(row.CREATED_AT).format('D MMM YYYY')}`;
        return `
          <ul class="list-unstyled m-0">
            <li class="fw-bolder">${creatorName}</li>
            <li>${createdAt}</li>
          </ul>
        `;
      },
    },
    {
      targets: 11,
      render: function (data, type, row) {
        var deleteBtn = `
          <div class="dropdown-divider opacity-75"></div>
          <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
            <i class="fas fa-trash text-danger mr-3"></i> Delete
          </a>
        `;

        if (curDIVISIONKEY != '291e255817') {
          deleteBtn = ['UNPAID', 'PAID'].includes(row.STATUS_PEMBAYARAN)
            ? ''
            : `
            <div class="dropdown-divider opacity-75"></div>
            <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
              <i class="fas fa-trash text-danger mr-3"></i> Delete
            </a>
          `;
        }
        return `
          <div class="dropdown dropdown-inline">
              <button type="button" class="btn btn-light-dark btn-icon btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="ki ki-bold-more-hor"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item fw-bolder btnEditBudget" href="javascript:;" data-id="${row.REC_ID}">
                  <i class="fas fa-pencil-alt mr-3"></i> Edit
                </a>
                ${deleteBtn}
              </div>
          </div>
        `;
      },
    },
  ],
  mediaPartnerColumnDefs = [
    {
      targets: 0,
      render: function (data, type, row) {
        return row.NAME;
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        let $color = 'danger';
        switch (row.STATUS) {
          case 'ON PROCESS':
            $color = 'warning';
            break;
          case 'DEAL':
            $color = 'success';
            break;
        }
        return `<span class="label label-inline label-${$color} text-uppercase fw-bolder">${row.STATUS}</span>`;
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        var txtColor = 'light-dark';
        if (row.STATUS_PEMBAYARAN == 'UNPAID') {
          txtColor = 'danger';
        } else if (row.STATUS_PEMBAYARAN == 'PAID') {
          txtColor = 'success';
        }
        return `<span class="label label-inline label-${txtColor} text-uppercase fw-bolder">${row.STATUS_PEMBAYARAN}</span>`;
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
        return additionalsDT?.notes ? `<div ${additionalsDT.notes.length >= 50 ? `class="togglePopover" data-toggle="popover" data-content="${additionalsDT.notes}"` : ''}>${nl2br(ellipseText(additionalsDT.notes, 50, true))}</div>` : '-';
      },
    },
    {
      targets: 4,
      render: function (data, type, row) {
        return !row.TOTAL ? '-' : `${number_format(row.TOTAL, 'IDR')} ${row.PPN && row.PPN != 0 ? `(<span class="fw-bolder">${row.PPN}%</span>)` : ''}`;
      },
    },
    {
      targets: 5,
      render: function (data, type, row) {
        return !row.GRANDTOTAL ? '-' : `<span class="text-decoration-underline">${number_format(row.GRANDTOTAL, 'IDR')}</span>`;
      },
    },
    {
      targets: 6,
      render: function (data, type, row) {
        let invoiceFile = '',
          approvalFile = '';

        invoiceFile = !row.FILE
          ? invoiceFile
          : `
          <li class="d-flex flex-start">
            <a href="${row.FILE}" class="btn btn-sm btn-light-warning text-dark fw-bolder border border-warning btn-block mb-3" target="_blank">Invoice File</a>
          </li>
        `;

        if (row?.INVOICE && row?.INVOICE_DATA?.APPROVE_FILE) {
          let defPath = `${defaultBugetApprovalFile}/${row.EVENT_ID}/BUKTI`;
          approvalFile = `
          <li class="d-flex flex-start">
            <a href="${defPath}/${row.INVOICE_DATA.APPROVE_FILE}" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block" target="_blank">Payment Approval</a>
          </li>
        `;
        }

        return `
          <ul class="list-unstyled">
            ${invoiceFile}
            ${approvalFile}
          </ul>
        `;
      },
    },
    {
      targets: 7,
      render: function (data, type, row) {
        let additionalFiles = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        if (additionalsDT?.other_files) {
          $.each(additionalsDT.other_files, function (i, value) {
            // additionalFiles += `<button type="button" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block">Additional Docs</button>`
            additionalFiles += `
            <li class="d-flex flex-start">
              <a href="${value}" class="btn btn-sm btn-light-dark fw-bolder border border-dark btn-block mb-3" target="_blank">Docs ${++i}</a>
            </li>
          `;
          });
        }

        return `
        <ul class="list-unstyled">
          ${additionalFiles}
        </ul>
      `;
      },
    },
    {
      targets: 8,
      render: function (data, type, row) {
        let creatorName = row.CREATED_NAME.length < 10 ? row.CREATED_NAME : `<span class="togglePopover" data-toggle="popover" data-content="${row.CREATED_NAME}">${ellipseText(row.CREATED_NAME, 10, true)}</span>`,
          createdAt = !row.CREATED_AT ? '-' : `${moment(row.CREATED_AT).format('D MMM YYYY')}`;
        return `
          <ul class="list-unstyled m-0">
            <li class="fw-bolder">${creatorName}</li>
            <li>${createdAt}</li>
          </ul>
        `;
      },
    },
    {
      targets: 9,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : null,
          ctaURLBacklink = additionalsDT?.backlink ? `<a target="_blank" href="${additionalsDT.backlink}" class="dropdown-item font-weight-bolder d-flex flex-start" target="_blank"><i class="fas fa-external-link-alt mr-3"></i> View<br>URL Backlink </a>` : '',
          ctaURLPublish = additionalsDT?.link_publish ? `<a target="_blank" href="${additionalsDT.link_publish}" class="dropdown-item font-weight-bolder d-flex flex-start" target="_blank"><i class="fas fa-external-link-alt mr-3"></i> View<br>URL Publish </a>` : '';
        var deleteBtn = `
          <div class="dropdown-divider opacity-75"></div>
          <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
            <i class="fas fa-trash text-danger mr-3"></i> Delete
          </a>
        `;

        if (curDIVISIONKEY != '291e255817') {
          deleteBtn = ['UNPAID', 'PAID'].includes(row.STATUS_PEMBAYARAN)
            ? ''
            : `
            <div class="dropdown-divider opacity-75"></div>
            <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
              <i class="fas fa-trash text-danger mr-3"></i> Delete
            </a>
          `;
        }

        return `
          <div class="dropdown dropdown-inline">
            <button type="button" class="btn btn-light-dark btn-icon btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="ki ki-bold-more-hor"></i>
            </button>
            <div class="dropdown-menu">
              ${ctaURLBacklink}
              ${ctaURLPublish}
              <a class="dropdown-item fw-bolder btnEditBudget" href="javascript:;" data-id="${row.REC_ID}">
                <i class="fas fa-pencil-alt mr-3"></i> Edit
              </a>
              ${deleteBtn}
            </div>
          </div>
        `;
      },
    },
  ],
  entertainColumnDefs = [
    {
      targets: 0,
      render: function (data, type, row) {
        return row.NAME ?? '-';
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        var txtColor = 'light-dark';
        if (row.STATUS_PEMBAYARAN == 'UNPAID') {
          txtColor = 'danger';
        } else if (row.STATUS_PEMBAYARAN == 'PAID') {
          txtColor = 'success';
        }
        return `<span class="label label-inline label-${txtColor} text-uppercase fw-bolder">${row.STATUS_PEMBAYARAN}</span>`;
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
        return additionalsDT?.notes ? `<div ${additionalsDT.notes.length >= 50 ? `class="togglePopover" data-toggle="popover" data-content="${additionalsDT.notes}"` : ''}>${nl2br(ellipseText(additionalsDT.notes, 50, true))}</div>` : '-';
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        return !row.TOTAL ? '-' : `${number_format(row.TOTAL, 'IDR')} ${row.PPN && row.PPN != 0 ? `(<span class="fw-bolder">${row.PPN}%</span>)` : ''}`;
      },
    },
    {
      targets: 4,
      render: function (data, type, row) {
        return !row.GRANDTOTAL ? '-' : `<span class="text-decoration-underline">${number_format(row.GRANDTOTAL, 'IDR')}</span>`;
      },
    },
    {
      targets: 5,
      render: function (data, type, row) {
        let invoiceFile = '',
          approvalFile = '';

        invoiceFile = !row.FILE
          ? invoiceFile
          : `
          <li class="d-flex flex-start">
            <a href="${row.FILE}" class="btn btn-sm btn-light-warning text-dark fw-bolder border border-warning btn-block mb-3" target="_blank">Invoice File</a>
          </li>
        `;

        if (row?.INVOICE && row?.INVOICE_DATA?.APPROVE_FILE) {
          let defPath = `${defaultBugetApprovalFile}/${row.EVENT_ID}/BUKTI`;
          approvalFile = `
          <li class="d-flex flex-start">
            <a href="${defPath}/${row.INVOICE_DATA.APPROVE_FILE}" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block" target="_blank">Payment Approval</a>
          </li>
        `;
        }

        return `
          <ul class="list-unstyled">
            ${invoiceFile}
            ${approvalFile}
          </ul>
        `;
      },
    },
    {
      targets: 6,
      render: function (data, type, row) {
        let additionalFiles = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        if (additionalsDT?.other_files) {
          $.each(additionalsDT.other_files, function (i, value) {
            // additionalFiles += `<button type="button" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block">Additional Docs</button>`
            additionalFiles += `
            <li class="d-flex flex-start">
              <a href="${value}" class="btn btn-sm btn-light-dark fw-bolder border border-dark btn-block mb-3" target="_blank">Docs ${++i}</a>
            </li>
          `;
          });
        }

        return `
        <ul class="list-unstyled">
          ${additionalFiles}
        </ul>
      `;
      },
    },
    {
      targets: 7,
      render: function (data, type, row) {
        let creatorName = row.CREATED_NAME.length < 10 ? row.CREATED_NAME : `<span class="togglePopover" data-toggle="popover" data-content="${row.CREATED_NAME}">${ellipseText(row.CREATED_NAME, 10, true)}</span>`,
          createdAt = !row.CREATED_AT ? '-' : `${moment(row.CREATED_AT).format('D MMM YYYY')}`;
        return `
          <ul class="list-unstyled m-0">
            <li class="fw-bolder">${creatorName}</li>
            <li>${createdAt}</li>
          </ul>
        `;
      },
    },
    {
      targets: 8,
      render: function (data, type, row) {
        var deleteBtn = `
          <div class="dropdown-divider opacity-75"></div>
          <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
            <i class="fas fa-trash text-danger mr-3"></i> Delete
          </a>
        `;

        if (curDIVISIONKEY != '291e255817') {
          deleteBtn = ['UNPAID', 'PAID'].includes(row.STATUS_PEMBAYARAN)
            ? ''
            : `
            <div class="dropdown-divider opacity-75"></div>
            <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
              <i class="fas fa-trash text-danger mr-3"></i> Delete
            </a>
          `;
        }
        return `
          <div class="dropdown dropdown-inline">
              <button type="button" class="btn btn-light-dark btn-icon btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="ki ki-bold-more-hor"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item fw-bolder btnEditBudget" href="javascript:;" data-id="${row.REC_ID}">
                  <i class="fas fa-pencil-alt mr-3"></i> Edit
                </a>
                ${deleteBtn}
              </div>
          </div>
        `;
      },
    },
  ],
  onlineAdsColumnDefs = [
    {
      targets: 0,
      render: function (data, type, row, meta) {
        return row.NAME ?? '-';
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
        return additionalsDT?.type ? ucwords(additionalsDT.type) : '-';
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
        return additionalsDT?.notes ? `<div ${additionalsDT.notes.length >= 50 ? `class="togglePopover" data-toggle="popover" data-content="${additionalsDT.notes}"` : ''}>${nl2br(ellipseText(additionalsDT.notes, 50, true))}</div>` : '-';
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        return !row.TOTAL ? '-' : `${number_format(row.TOTAL, 'IDR')} ${row.PPN && row.PPN != 0 ? `(<span class="fw-bolder">${row.PPN}%</span>)` : ''}`;
      },
    },
    {
      targets: 4,
      render: function (data, type, row) {
        return !row.GRANDTOTAL ? '-' : `<span class="text-decoration-underline">${number_format(row.GRANDTOTAL, 'IDR')}</span>`;
      },
    },
    {
      targets: 5,
      render: function (data, type, row) {
        let invoiceFile = '',
          approvalFile = '';

        invoiceFile = !row.FILE
          ? invoiceFile
          : `
          <li class="d-flex flex-start">
            <a href="${row.FILE}" class="btn btn-sm btn-light-warning text-dark fw-bolder border border-warning btn-block mb-3" target="_blank">Invoice File</a>
          </li>
        `;

        if (row?.INVOICE && row?.INVOICE_DATA?.APPROVE_FILE) {
          let defPath = `${defaultBugetApprovalFile}/${row.EVENT_ID}/BUKTI`;
          approvalFile = `
          <li class="d-flex flex-start">
            <a href="${defPath}/${row.INVOICE_DATA.APPROVE_FILE}" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block" target="_blank">Payment Approval</a>
          </li>
        `;
        }

        return `
          <ul class="list-unstyled">
            ${invoiceFile}
            ${approvalFile}
          </ul>
        `;
      },
    },
    {
      targets: 6,
      render: function (data, type, row) {
        let additionalFiles = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        if (additionalsDT?.other_files) {
          $.each(additionalsDT.other_files, function (i, value) {
            // additionalFiles += `<button type="button" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block">Additional Docs</button>`
            additionalFiles += `
            <li class="d-flex flex-start">
              <a href="${value}" class="btn btn-sm btn-light-dark fw-bolder border border-dark btn-block mb-3" target="_blank">Docs ${++i}</a>
            </li>
          `;
          });
        }

        return `
        <ul class="list-unstyled">
          ${additionalFiles}
        </ul>
      `;
      },
    },
    {
      targets: 7,
      render: function (data, type, row) {
        let creatorName = row.CREATED_NAME.length < 10 ? row.CREATED_NAME : `<span class="togglePopover" data-toggle="popover" data-content="${row.CREATED_NAME}">${ellipseText(row.CREATED_NAME, 10, true)}</span>`,
          createdAt = !row.CREATED_AT ? '-' : `${moment(row.CREATED_AT).format('D MMM YYYY')}`;
        return `
          <ul class="list-unstyled m-0">
            <li class="fw-bolder">${creatorName}</li>
            <li>${createdAt}</li>
          </ul>
        `;
      },
    },
    {
      targets: 8,
      render: function (data, type, row) {
        var deleteBtn = `
          <div class="dropdown-divider opacity-75"></div>
          <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
            <i class="fas fa-trash text-danger mr-3"></i> Delete
          </a>
        `;

        if (curDIVISIONKEY != '291e255817') {
          deleteBtn = ['UNPAID', 'PAID'].includes(row.STATUS_PEMBAYARAN)
            ? ''
            : `
            <div class="dropdown-divider opacity-75"></div>
            <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
              <i class="fas fa-trash text-danger mr-3"></i> Delete
            </a>
          `;
        }
        return `
          <div class="dropdown dropdown-inline">
              <button type="button" class="btn btn-light-dark btn-icon btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="ki ki-bold-more-hor"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item fw-bolder btnEditBudget" href="javascript:;" data-id="${row.REC_ID}">
                  <i class="fas fa-pencil-alt mr-3"></i> Edit
                </a>
                ${deleteBtn}
              </div>
          </div>
        `;
      },
    },
  ],
  defaultsColumnDefs = [
    {
      targets: 0,
      render: function (data, type, row) {
        return row.NAME ?? '-';
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        var txtColor = 'light-dark';
        if (row.STATUS_PEMBAYARAN == 'UNPAID') {
          txtColor = 'danger';
        } else if (row.STATUS_PEMBAYARAN == 'PAID') {
          txtColor = 'success';
        }
        return `<span class="label label-inline label-${txtColor} text-uppercase fw-bolder">${row.STATUS_PEMBAYARAN}</span>`;
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        let additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;
        return additionalsDT?.notes ? `<div ${additionalsDT.notes.length >= 50 ? `class="togglePopover" data-toggle="popover" data-content="${additionalsDT.notes}"` : ''}>${nl2br(ellipseText(additionalsDT.notes, 50, true))}</div>` : '-';
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        return !row.TOTAL ? '-' : `${number_format(row.TOTAL, 'IDR')} ${row.PPN && row.PPN != 0 ? `(<span class="fw-bolder">${row.PPN}%</span>)` : ''}`;
      },
    },
    {
      targets: 4,
      render: function (data, type, row) {
        return !row.GRANDTOTAL ? '-' : `<span class="text-decoration-underline">${number_format(row.GRANDTOTAL, 'IDR')}</span>`;
      },
    },
    {
      targets: 5,
      render: function (data, type, row) {
        let invoiceFile = '',
          approvalFile = '';

        invoiceFile = !row.FILE
          ? invoiceFile
          : `
          <li class="d-flex flex-start">
            <a href="${row.FILE}" class="btn btn-sm btn-light-warning text-dark fw-bolder border border-warning btn-block mb-3" target="_blank">Invoice File</a>
          </li>
        `;

        if (row?.INVOICE && row?.INVOICE_DATA?.APPROVE_FILE) {
          let defPath = `${defaultBugetApprovalFile}/${row.EVENT_ID}/BUKTI`;
          approvalFile = `
          <li class="d-flex flex-start">
            <a href="${defPath}/${row.INVOICE_DATA.APPROVE_FILE}" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block" target="_blank">Payment Approval</a>
          </li>
        `;
        }

        return `
          <ul class="list-unstyled">
            ${invoiceFile}
            ${approvalFile}
          </ul>
        `;
      },
    },
    {
      targets: 6,
      render: function (data, type, row) {
        let additionalFiles = '',
          additionalsDT = row.ADDITIONALS ? JSON.parse(row.ADDITIONALS) : false;

        if (additionalsDT?.other_files) {
          $.each(additionalsDT.other_files, function (i, value) {
            // additionalFiles += `<button type="button" class="btn btn-sm btn-light-info text-dark fw-bolder border border-info btn-block">Additional Docs</button>`
            additionalFiles += `
            <li class="d-flex flex-start">
              <a href="${value}" class="btn btn-sm btn-light-dark fw-bolder border border-dark btn-block mb-3" target="_blank">Docs ${++i}</a>
            </li>
          `;
          });
        }

        return `
        <ul class="list-unstyled">
          ${additionalFiles}
        </ul>
      `;
      },
    },
    {
      targets: 7,
      render: function (data, type, row) {
        let creatorName = row.CREATED_NAME.length < 10 ? row.CREATED_NAME : `<span class="togglePopover" data-toggle="popover" data-content="${row.CREATED_NAME}">${ellipseText(row.CREATED_NAME, 10, true)}</span>`,
          createdAt = !row.CREATED_AT ? '-' : `${moment(row.CREATED_AT).format('D MMM YYYY')}`;
        return `
          <ul class="list-unstyled m-0">
            <li class="fw-bolder">${creatorName}</li>
            <li>${createdAt}</li>
          </ul>
        `;
      },
    },
    {
      targets: 8,
      render: function (data, type, row) {
        var deleteBtn = `
          <div class="dropdown-divider opacity-75"></div>
          <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
            <i class="fas fa-trash text-danger mr-3"></i> Delete
          </a>
        `;

        if (curDIVISIONKEY != '291e255817') {
          deleteBtn = ['UNPAID', 'PAID'].includes(row.STATUS_PEMBAYARAN)
            ? ''
            : `
            <div class="dropdown-divider opacity-75"></div>
            <a class="dropdown-item fw-bolder text-danger btnDeleteBudget" data-id="${row.REC_ID}" data-invoice="${row.INVOICE}" href="javascript:;">
              <i class="fas fa-trash text-danger mr-3"></i> Delete
            </a>
          `;
        }
        return `
          <div class="dropdown dropdown-inline">
              <button type="button" class="btn btn-light-dark btn-icon btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="ki ki-bold-more-hor"></i>
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item fw-bolder btnEditBudget" href="javascript:;" data-id="${row.REC_ID}">
                  <i class="fas fa-pencil-alt mr-3"></i> Edit
                </a>
                ${deleteBtn}
              </div>
          </div>
        `;
      },
    },
  ],
  designOrderColumnDefs = [
    {
      targets: 0,
      render: function (data, type, row) {
        return row.DESCRIPTION.length >= 1 ? nl2br(ellipseText(row.DESCRIPTION, 300, true)) : `<span class="text-muted opacity-75">No Description</span>`;
      },
    },
    {
      targets: 1,
      render: function (data, type, row) {
        let dueDate = new Date(row.DUE_DATE);
        return dueDate >= curDATE ? row.DUE_DATE : `<span class="fw-bolder text-danger">${row.DUE_DATE}</span>`;
      },
    },
    {
      targets: 2,
      render: function (data, type, row) {
        return row.STATUS == 'INCOMPLETED' ? `<span class="label label-inline label-danger text-uppercase">Incompleted</span>` : `<span class="label label-inline label-success text-uppercase">Completed</span>`;
      },
    },
    {
      targets: 3,
      render: function (data, type, row) {
        return row.HANDLE_BY;
      },
    },
  ];

let firstDT = $('#currentDT').val();
switch (firstDT) {
  case 'endorse':
    firstInitColumns = endorseColumns;
    firstInitColumnDefs = endorseColumnDefs;
    break;
  case 'student_share':
    firstInitColumns = studentShareColumns;
    firstInitColumnDefs = studentShareColumnDefs;
    break;
  case 'media_offline':
    firstInitColumns = mediaOfflineColumns;
    firstInitColumnDefs = mediaOfflineColumnDefs;
    break;
  case 'media_partner':
    firstInitColumns = mediaPartnerColumns;
    firstInitColumnDefs = mediaPartnerColumnDefs;
    break;
  case 'venue':
    firstInitColumns = venueColumns;
    firstInitColumnDefs = venueColumnDefs;
  case 'entertain':
    firstInitColumns = entertainColumns;
    firstInitColumnDefs = entertainColumnDefs;
    break;
    break;
  case 'online_ads':
    firstInitColumns = onlineAdsColumns;
    firstInitColumnDefs = onlineAdsColumnDefs;
    break;
  default:
    firstInitColumns = defaultsColumns;
    firstInitColumnDefs = defaultsColumnDefs;
    break;
}

let dt_design_order = $('#dt_design_order').DataTable();
var defaultConfigDt = {
  processing: true,
  serverSide: true,
  ordering: false,
  lengthMenu: [10, 25, 50, 100, 200],
  searchDelay: 1000,
  dom: '<t><"d-flex flex-stack"<l><i><p>>',
  language: {
    loadingRecords: `<div class="d-flex flex-center"> Loading ${svgLoader}</div>`,
    processing: `<div class="d-flex flex-center"> Fetching Data ${svgLoader}</div>`,
  },
  ajax: {
    url: `${BASE_URL}Expo_Packages/getBudgetDetails`,
    type: 'POST',
    data: function (d) {
      var labelNameCategory = ucwords(firstDT.replace('_', ' ')).replace(' ', '');
      param = {
        sorting: 'no-sorting',
        event_id: getUrlParameter('id'),
        budget_category_id: $(`#budget${labelNameCategory}Table`).data('category-id'),
      };
      $.extend(d, param);
      var param = $(`#dt_${firstDT}`).data('param');
      if (param) {
        $.extend(d, param);
      }
    },
  },
  columns: firstInitColumns,
  columnDefs: firstInitColumnDefs,
};

if (userAgent != 'mobile') {
  defaultConfigDt.fixedColumns = { left: 1 };
  defaultConfigDt.fixedHeader = true;
}
var dt_budget_list = $(`#dt_${firstDT}`).DataTable(defaultConfigDt);

const reInitDatatableBudget = (globalColumns, globalColumnDefs, activeTab, categoryID) => {
  dt_budget_list.clear().destroy();
  $('#currentDT').val(activeTab);

  globalColumns = categoryID == '847336c1b4' ? venueColumns : globalColumns;
  globalColumns = categoryID == '8b1cd77c6e' ? entertainColumns : globalColumns;
  globalColumns = categoryID == 'c7111eb453' ? mediaOfflineColumns : globalColumns;
  globalColumns = categoryID == '2cdabef865' ? endorseColumns : globalColumns;
  globalColumns = categoryID == '157043ab66' ? studentShareColumns : globalColumns;
  globalColumns = categoryID == 'cc9389d364' ? onlineAdsColumns : globalColumns;
  globalColumns = categoryID == '2e50426398' ? mediaPartnerColumns : globalColumns;
  globalColumns = categoryID == 'f5c8c4d131' ? defaultsColumns : globalColumns;
  globalColumns = categoryID == 'd1b3039efe' ? defaultsColumns : globalColumns;

  globalColumnDefs = categoryID == '847336c1b4' ? venueColumnDefs : globalColumnDefs;
  globalColumnDefs = categoryID == '8b1cd77c6e' ? entertainColumnDefs : globalColumnDefs;
  globalColumnDefs = categoryID == 'c7111eb453' ? mediaOfflineColumnDefs : globalColumnDefs;
  globalColumnDefs = categoryID == '2cdabef865' ? endorseColumnDefs : globalColumnDefs;
  globalColumnDefs = categoryID == '157043ab66' ? studentShareColumnDefs : globalColumnDefs;
  globalColumnDefs = categoryID == 'cc9389d364' ? onlineAdsColumnDefs : globalColumnDefs;
  globalColumnDefs = categoryID == '2e50426398' ? mediaPartnerColumnDefs : globalColumnDefs;
  globalColumnDefs = categoryID == 'f5c8c4d131' ? defaultsColumnDefs : globalColumnDefs;
  globalColumnDefs = categoryID == 'd1b3039efe' ? defaultsColumnDefs : globalColumnDefs;

  var configDT = {
    processing: true,
    serverSide: true,
    ordering: false,
    lengthMenu: [10, 25, 50, 100, 200],
    searchDelay: 1000,
    dom: '<t><"d-flex flex-stack"<l><i><p>>',
    language: {
      loadingRecords: `<div class="d-flex flex-center">Loading ${svgLoader}</div>`,
      processing: `<div class="d-flex flex-center">Fetching Data ${svgLoader}</div>`,
    },
    ajax: {
      url: `${BASE_URL}Expo_Packages/getBudgetDetails`,
      type: 'POST',
      data: function (d) {
        param = {
          sorting: 'no-sorting',
          event_id: getUrlParameter('id'),
          budget_category_id: categoryID,
        };

        var budgetSearch = $('#dt_budget_search').val();
        if (budgetSearch) {
          param['search[value]'] = budgetSearch;
        }

        $.extend(d, param);
        var param = $(`#dt_${activeTab}`).data('param');
        if (param) {
          $.extend(d, param);
        }
      },
    },
    columns: globalColumns,
    columnDefs: globalColumnDefs,
  };

  if (userAgent != 'mobile') {
    configDT.fixedColumns = { left: 1 };
    configDT.fixedHeader = true;
  }
  dt_budget_list = $(`#dt_${activeTab}`).DataTable(configDT);
};

const initDesignOrderScript = () => {
  dt_design_order.clear().destroy();
  dt_design_order = $('#dt_design_order').DataTable({
    processing: true,
    serverSide: true,
    ordering: false,
    lengthMenu: [10, 25, 50, 100, 200],
    searchDelay: 1000,
    dom: '<t><"d-flex flex-stack"<l><i><p>>',
    language: {
      loadingRecords: `<div class="d-flex flex-center">Loading ${svgLoader}</div>`,
      processing: `<div class="d-flex flex-center">Fetching Data ${svgLoader}</div>`,
    },
    ajax: {
      url: `${BASE_URL}C_Event/designOrderDT`,
      type: 'POST',
      data: function (d) {
        param = {
          sorting: 'no-sorting',
          event_id: getUrlParameter('id'),
        };
        $.extend(d, param);
        var param = $('#dt_design_order').data('param');
        if (param) {
          $.extend(d, param);
        }
      },
    },
    error: function (resp) {
      const { header, message, status } = resp.responseJSON;
      makeSwal(header, message, status);
    },
    columns: designOrderColumns,
    columnDefs: designOrderColumnDefs,
  });
};

// **Script Listerner**
const initListenerBudget = () => {
  $(document).on('shown.bs.collapse', '.accordion-body', function (e) {
    let globalColumns,
      globalColumnDefs,
      activeTab = $(this).data('name'),
      categoryID = $(this).data('category-id');

    reInitDatatableBudget(globalColumns, globalColumnDefs, activeTab, categoryID);
  });

  $('#btnAddBudget').on('click', function (e) {
    e.preventDefault();
    $('#title_modal_budget').text('Add Budget');
    $('#form_budget_mode').val('add');
    $('.container_add_button').show();
  });

  const reindexBudgetForm = () => {
    $('#form_budget').attr('data-category-index', 0);
    $('.container_first_repeater').each(function (newIndex) {
      let tempIndex = newIndex;
      $('#form_budget').attr('data-category-index', tempIndex);

      // Reindex all form inputs
      $(this)
        .find('input[name^="other_files"]')
        .each(function () {
          $(this).attr('name', `other_files[${tempIndex}][]`);
        });
    });
  };

  $(document).on('click', '.btnDeleteBudget', function (e) {
    e.preventDefault();
    Swal.fire({
      title: 'Information!',
      html: `Anda yakin ingin menghapus data ini, jika iya data tidak dapat dikembalikan!`,
      icon: 'warning',
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Close',
      customClass: {
        confirmButton: 'btn font-weight-boldest btn-light-danger',
        cancelButton: 'btn font-weight-boldest btn-light',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        $.ajax({
          url: `${BASE_URL}C_Event/budgetDestroy`,
          method: 'POST',
          dataType: 'JSON',
          data: {
            id: $(this).data('id'),
            invoice_id: $(this).data('invoice'),
          },
          success: function (response) {
            const { status, header, message } = response;
            Swal.fire({ title: header, text: message, icon: status }).then((result) => {
              initTotalBudgeting();
              dt_budget_list.ajax.reload();
            });
          },
          error: function (data) {
            Swal.fire({
              title: data.statusText,
              html: data.responseText,
              icon: 'error',
            });
          },
        });
      }
    });
  });

  // new budget script
  $(document).on('click', '.btnAddRepeater', function (e) {
    e.preventDefault();

    var ctr = 0;
    var elemContainer = $('.container_first_repeater');
    elemContainer.each(function (i, v) {
      ctr = i;
    });

    var lastMediaSelected = 0,
      lastMediaNameSelected = '';
    if (ctr < 5) {
      var newContainer = $('.container_first_repeater').first().clone();
      if ($('.media_offline_vendor_id').length) {
        lastMediaSelected = newContainer.find('.media_offline_vendor_id').val();
        lastMediaNameSelected = newContainer.find('.media_offline_vendor_name').val();
        newContainer.find('select.media_offline_vendor_id').empty().trigger('change');
      }
      if ($('.media_partner_vendor_id').length) {
        lastMediaSelected = newContainer.find('.media_partner_vendor_id').val();
        lastMediaNameSelected = newContainer.find('.media_partner_vendor_name').val();
      }
      if ($('.venue_id').length) {
        lastMediaSelected = newContainer.find('.venue_id').val();
        lastMediaNameSelected = newContainer.find('.venue_name').val();
      }
      newContainer.find('.container_delete_button').removeClass('d-none');
      newContainer.find('input[type="checkbox"]').prop('checked', false);
      newContainer.find('textarea').val('');
      newContainer.find('.containerPercentasePPN').hide();
      newContainer.find('.container-designOrder').hide();
      newContainer.find('.custom-file-label').html('Choose file');
      newContainer.find('input').val('');
      newContainer.find('select').val('');
      newContainer.find('.select2-container').remove();

      $('.container_add_button').after(newContainer);

      if ($('.select2-cities').length) {
        initDefaultSelect2(
          true,
          {
            endpoint: `${BASE_URL}Select2Controller/getCities`,
          },
          '.select2-cities',
          $('#modal_form_budget'),
          $(this).data('placeholder')
        );
      }

      if ($('.select2-employee').length) {
        initDefaultSelect2(
          true,
          {
            endpoint: `${BASE_URL}Select2Controller/getEmployees`,
            data: { is_group: true },
          },
          '.select2-employee',
          $('#modal_form_budget'),
          $(this).data('placeholder')
        );
      }

      if ($('.media_offline_vendor_id').length) {
        initDefaultSelect2(
          true,
          {
            endpoint: `${BASE_URL}/Select2Controller/getVendors`,
            data: {
              is_media_offline: true,
            },
          },
          '.media_offline_vendor_id',
          undefined,
          'Choose Media Offline',
          false,
          false,
          true,
          Infinity,
          false,
          {
            show: true,
            content: 'No results found. <a class="btn btn-sm btn-primary quickAddVendor">Create new Vendor</a>',
          },
          true
        );
      }

      if ($('.media_partner_vendor_id').length) {
        initDefaultSelect2(
          true,
          {
            endpoint: `${BASE_URL}/Select2Controller/getVendors`,
            data: {
              is_media_partner: true,
            },
          },
          '.media_partner_vendor_id',
          undefined,
          'Choose Media Partner',
          false,
          false,
          true,
          Infinity,
          false,
          {
            show: true,
            content: 'No results found. <a class="btn btn-sm btn-primary quickAddVendor">Create new Vendor</a>',
          },
          true
        );
      }

      if ($('.venue_id').length) {
        initDefaultSelect2(
          true,
          {
            endpoint: `${BASE_URL}/Select2Controller/getVendors`,
            data: {
              is_venue: true,
            },
          },
          '.venue_id',
          undefined,
          'Choose Venue',
          false,
          false,
          true,
          Infinity,
          false,
          {
            show: true,
            content: 'No results found. <a class="btn btn-sm btn-primary quickAddVendor">Create new Vendor</a>',
          },
          true
        );
      }

      if ($('.media_offline_materi_iklan').length) {
        initDefaultSelect2(
          true,
          {
            endpoint: `${BASE_URL}/Select2Controller/getVendorTypes`,
          },
          '.media_offline_materi_iklan',
          undefined,
          'Choose advertising materials'
        );
      }

      if ($('.select2-no-search').length) {
        initDefaultSelect2(false, null, '.select2-no-search', undefined, 'Choose...');
      }

      $('.maskCurrencyGlobal').mask('000.000.000.000.000', {
        reverse: true,
        translation: {
          0: { pattern: /\d/ },
          9: { pattern: /\d/, optional: true },
          Z: { pattern: /[\-\+]/, optional: true },
        },
      });

      $('.maskPpn').mask('000', { reverse: true });

      if ($('.media_offline_vendor_id').length) {
        var option = new Option(lastMediaNameSelected, lastMediaSelected, true, false);
        newContainer.find('select.media_offline_status').val('NOT YET').trigger('change');
        newContainer.find('select.media_offline_status_pembayaran').val('UNPAID').trigger('change');
        newContainer.find('select.media_offline_vendor_id').append(option).trigger('change');
        newContainer.find('input.media_offline_vendor_name').val(lastMediaNameSelected);
      }

      if ($('.media_partner_vendor_id').length) {
        var option = new Option(lastMediaNameSelected, lastMediaSelected, true, true);
        newContainer.find('select.media_partner_status').val('NOT YET').trigger('change');
        newContainer.find('select.media_partner_status_pembayaran').val('UNPAID').trigger('change');
        newContainer.find('select.media_partner_vendor_id').empty().append(option).trigger('change');
        newContainer.find('input.media_partner_vendor_name').val(lastMediaNameSelected);
      }

      if ($('.venue_id').length) {
        var option = new Option(lastMediaNameSelected, lastMediaSelected, true, true);
        newContainer.find('select.venue_paket_meeting').val('FULLDAY').trigger('change');
        newContainer.find('select.venue_status').val('NOT YET').trigger('change');
        newContainer.find('select.venue_status_pembayaran').val('UNPAID').trigger('change');
        newContainer.find('select.venue_id').empty().append(option).trigger('change');
        newContainer.find('input.venue_name').val(lastMediaNameSelected);
      }

      reindexBudgetForm();
      return;
    }

    reindexBudgetForm();

    Swal.fire({
      title: 'Information!',
      html: 'Maksimal hanya bisa tambah 5 data',
      icon: 'warning',
    });
  });

  $(document).on('click', '.btnDeleteRepeater', function (e) {
    e.preventDefault();

    $(this).parents('.container_first_repeater').remove();

    reindexBudgetForm();
  });

  // Begin submit form budget total
  var typingTimerEBudget,
    doneTypingIntervalEBudget = 500;
  $(document).on('keyup input', '.singleBudget', function (e) {
    e.preventDefault();

    clearTimeout(typingTimerEBudget);
    typingTimerEBudget = setTimeout(() => {
      var totalBudget = 0;
      $('.singleBudget').each(function () {
        let val = $(this)
          .val()
          .replace(/[^0-9]/g, ''); // remove non-numeric
        totalBudget += parseInt(val || 0);
      });

      $(`input[name="total_budget_event"]`).val(totalBudget).trigger('input');
    }, doneTypingIntervalEBudget);
  });

  $('#form_budget_total').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#modal-body-edit');
    $.ajax({
      url: `${BASE_URL}C_Event/updateBudgetTotal`,
      method: 'POST',
      dataType: 'JSON',
      data: $(this).serialize(),
      success: function (response) {
        makeKTBlock('#modal-body-edit', 'hide');
        const { status, header, message } = response;
        makeSwal(header, message, status, 'action', '385px', 'reload-tab#budget');
      },
      error: function (data) {
        Swal.fire({
          title: data.statusText,
          html: data.responseText,
          icon: 'error',
        });
        makeKTBlock('#modal-body-edit', 'hide');
      },
    });
  });
  // End submit form budget total

  // Begin submit form budget
  $('#form_budget').on('submit', function (e) {
    e.preventDefault();

    // Reindex input files first before trigger ajax
    reindexBudgetForm();

    KTApp.block('#form_budget', {
      overlayColor: '#7E8299',
      type: 'loader',
      state: 'primary',
      opacity: 0.3,
      size: 'lg',
    });

    const formData = new FormData($(this)[0]),
      formMode = $('#form_budget_mode').val(),
      prefixAction = formMode == 'add' ? 'budgetStore' : 'budgetUpdate';

    $.ajax({
      url: `${BASE_URL}C_Event/${prefixAction}`,
      method: 'POST',
      dataType: 'JSON',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      xhr: function () {
        const xhr = new window.XMLHttpRequest();
        //Upload progress
        xhr.upload.addEventListener(
          'progress',
          function (evt) {
            if (evt.lengthComputable) {
              const percentComplete = evt.loaded / evt.total;
              //Do something with upload progress
              const progressPercent = Math.round(percentComplete * 100);
              $('#btn-submit-budget').text(`Please wait... (${progressPercent}%)`);
            }
          },
          false
        );
        return xhr;
      },
      success: async function (response) {
        const { code, status, header, message, record } = response;
        KTApp.unblock('#form_budget');

        if (code == 200) {
          /** Kalau sukses, inject ke Firebase */
          try {
            if (formMode === 'add') {
              // Create notification data
              await processFirebase({
                creatorName: curUSERNAME,
                creatorNIP: curUSERSN,
                version: 2,
                data: JSON.stringify({
                  id: record.REC_ID,
                  invoiceID: record.INVOICE,
                  type: 'EVENT-BUDGET',
                  rawData: record,
                }),
              });

              Swal.fire({
                title: header,
                text: message,
                icon: status,
              }).then((_result) => {
                $('.modal').modal('hide');
                dt_budget_list.ajax.reload();
                setTimeout(() => {
                  initTotalBudgeting();
                }, 500);
              });
            } else {
              Swal.fire({
                title: header,
                text: message,
                icon: status,
              }).then((_result) => {
                $('.modal').modal('hide');
                dt_budget_list.ajax.reload();
                setTimeout(() => {
                  initTotalBudgeting();
                }, 500);
              });
            }
          } catch (err) {
            console.log(err);

            Swal.fire({
              html: '<strong>Cannot add budget! Please try again later</strong>',
              icon: 'warning',
              confirmButtonText: 'Close',
            });
          }
        } else {
          makeSwal(header, message, status);
        }
      },
      error: function (data) {
        KTApp.unblock('#form_budget');

        const { header, message, status } = data.responseJSON;
        makeSwal(header, message, status);
      },
    });

    setTimeout(() => {
      $('#btn-submit-budget').text(`Save changes`);
    }, 500);
  });
  // End submit form budget

  $('#modal_form_vendor').on('submit', function (e) {
    e.preventDefault();
    $.ajax({
      url: `${BASE_URL}VendorManagementController/store`,
      method: 'POST',
      dataType: 'JSON',
      data: $(this).serialize(),
      success: function (response) {
        const { status, header, message } = response;
        Swal.fire({
          title: header,
          text: message,
          icon: status,
        }).then((result) => {
          if (result.isConfirmed) {
            $(`#modal_form_vendor`)[0].reset();
            $(`#form_vendor_mode`).val('add');
            $(`#modalVendorLabel`).text(`Create Vendor`);
            $(`#vendor_type`).val('vendor');
            $(`#vendor_type_id`).val('').trigger('change');
            $(`#vendor_city_id`).val('').trigger('change');

            $('#modalVendor').modal('hide');
          }
        });
      },
      error: function (data) {
        Swal.fire({
          title: data.statusText,
          html: data.responseText,
          icon: 'error',
        });
      },
    });
  });

  $('.maskCurrencyGlobal').mask('000.000.000.000.000', {
    reverse: true,
    translation: {
      0: {
        pattern: /\d/,
      },
      9: {
        pattern: /\d/,
        optional: true,
      },
      Z: {
        pattern: /[\-\+]/,
        optional: true,
      },
    },
  });

  $('.maskPpn').mask('000', {
    reverse: true,
  });

  if ($('#vendor_type_id').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}Select2Controller/getVendorCategoryMaster`,
      },
      '#vendor_type_id',
      undefined,
      $(this).data('placeholder')
    );
  }

  if ($('#vendor_city_id').length) {
    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}Select2Controller/getAreas`,
      },
      '#vendor_city_id',
      undefined,
      $(this).data('placeholder')
    );
  }

  $('#modal_form_budget').on('shown.bs.modal', function () {
    $('#form_budget')[0].reset();
    $('.select2-ajax').val('');
    $('#body_form_budget').html('');
    $('#event_id').val(getUrlParameter('id'));

    initDefaultSelect2(
      true,
      {
        endpoint: `${BASE_URL}C_Event/getBudgetCategories`,
      },
      '.select2-budget-categories',
      $('#modal_form_budget'),
      $(this).data('placeholder')
    );
  });

  $(document).on('change', '.invoice_file', function (e) {
    //get the file name
    var fileName = e.target.files[0].name;

    if (e.target.files[0].size > 10000000) {
      Swal.fire({
        title: 'File too large',
        text: 'Selected file is too large',
        icon: 'error',
        confirmButtonText: 'Ok',
      });

      $(this).val(null);
      setTimeout(() => {
        $(this).next('.custom-file-label').html('Choose file');
      }, 500);
    } else {
      setTimeout(() => {
        $(this).next('.custom-file-label').html(fileName);
      }, 500);
    }
  });

  $(document).on('change', '.other_files', function (e) {
    //get the file name
    var files = this.files;
    var validFiles = [];
    var maxSize = 2 * 1024 * 1024; //2 MB in bytes
    var errorMsg = '';

    // Display error message if any
    if (errorMsg) {
      makeSwal('Warning!', errorMsg, 'warning');
    }
    for (let i = 0; i < files.length; i++) {
      if (files[i].size <= maxSize) {
        validFiles.push(files[i]);
      } else {
        errorMsg += `File "${files[i].name}" exceeds 2 MB. <br>`;
      }
    }

    // Display the number of valid files selected
    if (validFiles.length > 0) {
      setTimeout(() => {
        $(this).next('.custom-file-label').html(`${validFiles.length} files selected.`);
      }, 500);
    } else {
      $(this).val(null);
      setTimeout(() => {
        $(this).next('.custom-file-label').html('Choose file');
      }, 500);
    }
  });
};

export { initTotalBudgeting, initAllBudgetFormScript, initListenerBudget, initDesignOrderScript };
